module.exports = __webpack_public_path__ + "static/media/logo06.c34b0fc8.svg";